module.exports = __webpack_public_path__ + "static/discord-1627e128a21aa255f7976af8e399807d.png";